var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{class:_vm.baseClass},[(_vm.toggleVisible)?_c('EpbToggle',{class:`${_vm.baseClass}__toggle`,attrs:{"options":_vm.toggleOptions,"value":_vm.value,"disabled":_vm.disabled},on:{"input":_vm.onTypeChange}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }